import { Controller as BaseController } from '@hotwired/stimulus';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { percentFormatter } from '../../../../javascript/modules/chartjs_utils';
export default class Controller extends BaseController {
  static values = { onGoing: Number, finished: Number, notStarted: Number };

  connect() {
    var ctx = document.getElementById('exam-status-graph');
    new Chart(ctx, {
      type: 'pie',
      data: {
        datasets: [
          {
            data: [this.finishedValue, this.notStartedValue, this.onGoingValue],
            backgroundColor: ['#E48E4E', '#5C457E', '#E06C9B'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          datalabels: {
            formatter: percentFormatter,
            labels: {
              name: {
                color: ['#FFFFFF'],
                offset: 10,
                font: {
                  size: '16px',
                },
              },
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }
}
